<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content [innerHtml]="message"></div>
<div mat-dialog-actions>
  <button mat-raised-button cdkFocusInitial class="mat-accent" [mat-dialog-close]>{{ buttonCaption }}</button>
</div>
